import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { ActionButton, IButtonStyles } from '@fluentui/react/lib/Button';
import type { IIconProps, IIconStyles } from '@fluentui/react/lib/Icon';
import { getPalette } from 'owa-theme';
import type AssetCommandDescriptor from '../assetCommands/AssetCommandDescriptor';
import loc from 'owa-localize';

const buttonStyles: IButtonStyles = {
    root: {
        fontSize: 12,
        height: 22,
        marginTop: 12,
        alignSelf: 'flex-start',
        color: getPalette().neutralSecondary,
        backgroundColor: getPalette().neutralLighter,
    },
    icon: {
        color: getPalette().neutralSecondary,
    },
};

const iconStyles: IIconStyles = {
    root: {
        fontSize: 12,
    },
};

export default observer(function AssetButton({
    command: { iconName, titleResourceId },
    onClick,
}: {
    command: AssetCommandDescriptor;
    onClick: () => void;
}) {
    const iconProps: IIconProps = {
        iconName,
        styles: iconStyles,
    };

    return (
        <ActionButton onClick={onClick} iconProps={iconProps} styles={buttonStyles}>
            {loc(titleResourceId)}
        </ActionButton>
    );
});
